<template>
  <HcSelect
    :value="value"
    :options="ufs"
    :disabled="disabled"
    :limpar="limpar"
    placeholder="UF"
    @input="onInput"
  />
</template>

<script>
import HcSelect from "./Select";

export default {
  name: "HcSelectUf",
  components: {
    HcSelect
  },
  props: ["value", "disabled", "limpar"],
  data,
  methods: {
    onInput
  }
};

function data() {
  return {
    ufs: [
      "AC",
      "AL",
      "AP",
      "AM",
      "BA",
      "CE",
      "DF",
      "ES",
      "GO",
      "MA",
      "MT",
      "MS",
      "MG",
      "PA",
      "PB",
      "PR",
      "PE",
      "PI",
      "RJ",
      "RN",
      "RS",
      "RO",
      "RR",
      "SC",
      "SP",
      "SE",
      "TO"
    ]
  };
}

function onInput(value) {
  this.$emit("input", value);
  this.$emit("change", value);
}
</script>
